import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_have_any_of_the_following_measures_in_place_to_the'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_have_any_of_the_following_measures_in_place_to_the',
  name: 'Does the facility have any of the following measures in place to ensure the safe handling of chemicals and hazardous substances?',
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'TRAINING_RECORDS_ON_CHEMICAL_USE_AND_HANDLING_AND_DISPOSAL_AND_',
      text: 'Training records on chemical use and handling and disposal and spill cleanup are maintained for the last 12 months',
      externalIds: [
        {
          id: 'hs-27-2x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'APPROPRIATE_CONTAINERS_ARE_USED_FOR_DISPENSING_ALL_CHEMICALS',
      text: 'Appropriate containers are used for dispensing all chemicals',
      externalIds: [
        {
          id: 'hs-27-3x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'WRITTEN_PROCEDURES_ARE_IN_PLACE_FOR_REPORTING_AND_RESPONDING_TO',
      text: 'Written procedures are in place for reporting and responding to chemical spills inside the production area',
      externalIds: [
        {
          id: 'hs-27-4x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'A_COMPLETE_SPILL_KIT_APPROPRIATE_FOR_THE_TYPES_AND_USE_OF_CHEMI',
      text: 'A complete spill kit (appropriate for the types and use of chemicals in the facility) is available for use',
      externalIds: [
        {
          id: 'hs-27-5x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'CHEMICALS_ARE_NOT_DISPOSED_OF_IN_WASTE_BIN_CONTAINERS_WHICH_ARE',
      text: 'Chemicals are not disposed of in waste bin containers which are generally used for food and drink',
      externalIds: [
        {
          id: 'hs-27-6x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NONE_OF_THE_ABOVE',
      text: 'None of the above',
      externalIds: [
        {
          id: 'hs-27-7x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'TRAINING_RECORDS_ON_CHEMICAL_USE_AND_HANDLING_AND_DISPOSAL_AND_',
                'APPROPRIATE_CONTAINERS_ARE_USED_FOR_DISPENSING_ALL_CHEMICALS',
                'WRITTEN_PROCEDURES_ARE_IN_PLACE_FOR_REPORTING_AND_RESPONDING_TO',
                'A_COMPLETE_SPILL_KIT_APPROPRIATE_FOR_THE_TYPES_AND_USE_OF_CHEMI',
                'CHEMICALS_ARE_NOT_DISPOSED_OF_IN_WASTE_BIN_CONTAINERS_WHICH_ARE',
                'NONE_OF_THE_ABOVE',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'hs-che-4',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 15360,
  sectionId: '2.2.9.5',
  impactArea: 'Chemicals and Hazardous Substances',
  impactAreaId: 'CHEMICALS_AND_HAZARDOUS_SUBSTANCES',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
